// Packages and components
import React, { useState } from 'react';
import { CheckBox } from 'grommet';

// Types
import type { SHDCheckboxProps } from './SHDCheckbox.d';

const SHDCheckbox: React.FC<SHDCheckboxProps> = ({
  className = 'checkbox',
  label,
  onChange,
  checked,
  ...props
}) => {
  // State
  const [isChecked, setChecked] = useState<boolean>(checked);

  // Handlers
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    onChange(event.target.checked);
  };

  return (
    <CheckBox
      {...props}
      checked={isChecked}
      className={`${className}__input`}
      label={label}
      onChange={handleOnChange}
    />
  );
};

export default SHDCheckbox;
